import React from 'react';

const TaskAssignedIcon = ({ size = 16 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
            <path d="M8.66667 3.33333H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8.66667 8H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8.66667 12.6667H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M2 11.3333L3.33333 12.6667L6 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M5.33333 2.66667H2.66667C2.29848 2.66667 2 2.96514 2 3.33333V6C2 6.36819 2.29848 6.66667 2.66667 6.66667H5.33333C5.70152 6.66667 6 6.36819 6 6V3.33333C6 2.96514 5.70152 2.66667 5.33333 2.66667Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default TaskAssignedIcon;
